import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidationErrors, ReactiveFormsModule} from '@angular/forms';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { logisticaModulo as diccionarios} from '../../logistica-diccionario';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';
import { CentroAlmacen } from '../../../traslado-logist/model/asignacion-centro.model';
import { ITiposViajesShort, ITrackingCarga, ITrackingDocumentos, ITrackingViajeByChofer, ITrackingViajes } from '../../model/modelTracking';
import { LogisticaService } from '../../service/logistica.services';
import { CatalogosLogisticaService } from '../../service/catalogosLogistica.service';
import { Placa } from 'src/app/model/datos-maestros/placa';
import { Chofer } from '../../../traslado-logist/model/model';
import { ComedorService } from 'src/app/aplicaciones-modulos/comedor/services/comedor.services';
import { ColDef } from 'ag-grid-community';
import { forkJoin } from 'rxjs';
import { IParametroLogistica } from '../../model/parametro-logistica.model';
import { dateGreaterThanValidator } from 'src/app/shared/validators/notWhiteSpacesValidator';

@Component({
  selector: 'app-tracking-convoy-cierre',
  templateUrl: './tracking-convoy-cierre.component.html',
  styleUrls: ['./tracking-convoy-cierre.component.css']
})

export class TrackingConvoyCierreComponent implements OnInit {

  public DAT_TITULOS    = diccionarios.titulos.convoy;
  public GLOBAL_TITULOS = diccionarios.titulos.global;
  public DAT_AG_GRID    = diccionarios.agGrid;
  public DAT_BTNCSS     = diccionarios.button.buttonsCss;

  public titleModal   : string;
  public loading      : boolean = false;
  public isCreate     : boolean = false;

  // Variables para el grid
  public frameworkComponents: any;
  public columnDefs     : ColDef[] = [];
  public rowData        : any[] = [];
  public rowSelection   : any;

  public gridApi        : any;
  public gridColumnApi  : any;
  public textoBuscar    : string;
  public usarioActual   : any;
  public defaultColDef  : ColDef;

  // Variables funcionales
  public listCentros    : CentroAlmacen [] = [];
  public listTipos      : ITiposViajesShort  [] = [];
  public listAgencias   : any[] = [];
  public selected       : any;

  public listViajes     : ITrackingViajes [] = [];

  //esta para usar para listar los viajes ya asigandos
  public listViajesAsignados:  ITrackingViajes [] = [];

  public listAsignaciones : any[] = [];
  public tablaCelds     : any;
  public fechaHoraInicio : any;
  public listConvoysParametro: IParametroLogistica[] = [];
  private listConvoysParametroRespaldo: IParametroLogistica[] | null = null;
  private observacionTemporalAgregada: boolean = false;
  public listViajesByChofer: ITrackingViajeByChofer[] = [];
  public listChoferesDropdown: Array<ITrackingViajeByChofer & { display: string }> = [];
  public selectedChoferViajeId: number | null = null;

  public filterSelected: string = "CONVOY_PLANIFICADO"; 

  public formulario = new FormGroup({
    idConvoy          : new FormControl(''),
    observacion       : new FormControl(''),
    estado            : new FormControl('', Validators.required),
    creadoPor         : new FormControl('', Validators.required),
    modificadoPor     : new FormControl(''),
    creado            : new FormControl(''),
    grupo             : new FormControl('', [Validators.required, Validators.maxLength(100)]),
    fechaSalida       : new FormControl('', Validators.required),
    });

  public formDetalle = new FormGroup({
    registro      : new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(4), Validators.pattern('^[0-9]*$')]),
    convoyId      : new FormControl(''),
    esLider       : new FormControl(false),
    viajeDetalle  : new FormControl('', Validators.required),
    placa         : new FormControl(''),
    furgon        : new FormControl(''),
    nombreProveedor: new FormControl(''),
    chofer        : new FormControl(''),
    });

  constructor(
    private utilServices  : UtilsService,
    private dmaestrosAPI  : DatosMaestrosService,
    private logisticaAPI  : LogisticaService,
    private nominaAPI     : ComedorService,
    private _catalogos    : CatalogosLogisticaService
  ) { }

  ngOnInit(): void {
    this.usarioActual = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    this.DAT_TITULOS = diccionarios.titulos.convoy;

    this.listar();
    this.cargarGridcomponent();
  }

  cargarGridcomponent() {
    this.frameworkComponents = { buttonRenderer: LfsaBotonEditarGridComponent, };
    this.columnDefs = this._catalogos.getColumnDefsConvoy();
    this.columnDefs.push(
      { cellRenderer: 'buttonRenderer', initialPinned: "left", width: 100, cellRendererParams: { onClick: this.editar.bind(this), label: 'Ver' } }
    );

    if(this.filterSelected == "CONVOY_PLANIFICADO"){
      this.columnDefs.push(
        { cellRenderer: 'buttonRenderer', initialPinned: "left", width: 150, cellRendererParams: { onClick: this.cerrarConvoy.bind(this), label: '=> Cerrar' } },
      );
    }

    this.defaultColDef = this._catalogos.getDefaultColDef();
    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  editar({rowData}){
    this.isCreate  = false;
    this.selected = rowData;
    this.titleModal = this.GLOBAL_TITULOS.tituloActualizar;
    this.fechaHoraInicio = this.utilServices.getFechayHoraActual();
    console.log("registro seleccionado", this.selected);
    this.listAsignaciones = [];

    this.formulario.reset();
    this.formDetalle.reset();
    this.formulario.patchValue(rowData);
    this.formulario.patchValue({ idConvoy: rowData.idConvoy });

    if(rowData.detalles?.length >0){
      this.formDetalle.get('convoyId').setValue(rowData.idConvoy);
      const esLiderVal = Array.isArray(rowData.detalles) && rowData.detalles.length > 0 ? (rowData.detalles[0].esLider == 1 ? true : false) : false;
      this.formDetalle.get('esLider').setValue(esLiderVal);
    }

    this.listAsignaciones = rowData.detalles;
    this.openModal();
  }

  listar(){
    this.loading = false;
    this.rowData = [];
    this.logisticaAPI.getConvoyByEstado(this.filterSelected).subscribe((res) => {
      if(res) this.rowData = res;
    }, (err) => {
      console.log(err.message);
    });

  }

  saveForm() {
    //this.getFormValidationErrors();
    if (this.formulario.invalid) {
        this.utilServices.mensajeErroToast("Seleccione el Convoy");
        return;
    }

    if (this.listAsignaciones.length == 0)
      {
        this.utilServices.mensajeErroToast("Falta detalles de Viajes");
        return;
      }
  }

  cerrarConvoy({ rowData }){
    rowData.estado = 'CONVOY_CERRADO';
    const data = rowData;

    this.utilServices.confirmarSincronoPromesa({
        title   : "¿Esta seguro que desea cerrar el convoy?",
        text    : 'CONVOY GRUPO: ' + rowData.idConvoy + " ID: " + rowData.idConvoy,
        action  : "Cerrar Convoy",
        funcion : this.logisticaAPI.updateConvoyCabecera(data)
      }).then(() => {
        this.loading = false;
        this.listar();
        this.closeModal();
      }).catch(() => {
        this.loading = false;
      });
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    this.saveForm();
  }

  enviarMails() {
    const idConvoy = this.formulario.get('idConvoy')?.value;
    if (!idConvoy) {
      this.utilServices.mensajeErroToast('No existe ID Convoy');
      return;
    }

    this.loading = true;
    this.utilServices.confirmarSincronoPromesa({
      title: '¿Enviar mails del convoy?',
      text: 'Convoy ' + idConvoy,
      action: 'Enviar mails',
      funcion: this.logisticaAPI.enviarMailsConvoy( idConvoy )
    }).then(() => {
      this.loading = false;
      this.utilServices.mensajeOKToast('Mails enviados');
    }).catch(() => {
      this.loading = false;
    });
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  onKeydown(event) {
    console.log(event);

    if ((event.key === 'Enter' && this.formulario.valid === true)){
        console.log('ENTER --> KEYDOWN');
      }

  }

  /** METODOS DE CONSULTAS  */
  getFormValidationErrors() {
    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;
    Object.keys(this.formulario.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formulario.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });
    console.log('Number of errors: ', totalErrors);
  }

  /*Metodos para proceso de carga de viajes*/
  addDetalle(){
    if (this.formulario.invalid) {
      this.utilServices.mensajeErroToast("Seleccione el Convoy");
      return;
    }

    let item = this.formDetalle.getRawValue();
    const viajeId = Number(item.viajeId);
    if (!viajeId) return;

    const existe = (this.listAsignaciones || []).some((d) => Number(d.viajeId) === viajeId);
    if (existe) {
      this.utilServices.mensajeErroToast('El viaje ya existe en el detalle');
      return;
    }

    if(!this.isCreate){
      item.idConvoy = this.selected.idConvoy;
      const payload = { ...item };
      delete payload.choferNombre;
      delete payload.nombreProveedor;
      delete payload.furgon;

      this.logisticaAPI.createConvoyDetalle(payload).subscribe((res) => {
        if(res){
          this.utilServices.mensajeOKToast("Detalle de Viaje actualizado");
          this.getDetalles();
          this.listar();
        }
      }, (err) => {
        console.log(err.message);
      });
    }else this.listAsignaciones.push(item);

  }

  getDetalles(){
    this.listAsignaciones = [];

    console.log("selected actual", this.selected);
    let viajeActual = this.selected.detalles[0].idViaje;

      this.logisticaAPI.getByConvoyDetalleViaje(this.selected.detalles[0].viajeId).subscribe((res) => {
        this.listAsignaciones = res;
        console.log("resultado de consulta de carga, ", res);
      }, (err) => {
        console.error(err.message);
        this.listAsignaciones = [];
      });
  }

  deleteDetalle(index, item){
    if(!this.isCreate){
      console.log("detalle a eliminar", item);
      this.logisticaAPI.deleteConvoyDetalle(item).subscribe((res) => {
          this.utilServices.mensajeOKToast("Detalle eliminada exitosamente");
          this.getDetalles();
          this.listar();
      }, (err) => {
        console.warn(err.message);
      });
    }
    else
      console.log("aqui elimina");
      this.listAsignaciones.splice(index, 1);

  }

  onChangeFiltros(event: any){
    this.rowData = [];
    this.filterSelected = event;

    console.log("filtrar por ===>", this.filterSelected);
    this.loading = true;
    this.cargarGridcomponent();

    this.logisticaAPI.getConvoyByEstado(event).subscribe((res) => {
      if(res) this.rowData = res;
    }, (err) => {
      console.log(err.message);
    });
 
    this.loading = false;
  }

}